import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared';
import {UserAccessComponent} from '@app/modules/settings/user-access/user-access.component';
import {InstitutionComponent} from './institution/institution.component';
import {UserManagementComponent} from '@app/modules/settings/user-management/user-management.component';
import {MedicineUnitComponent} from '@app/modules/settings/medicine-unit/medicine-unit.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'user-access',
        loadComponent: () => UserAccessComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/user-access'}
      },
      {
        path: 'institution',
        loadComponent: () => InstitutionComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/institution'}
      },
      {
        path: 'user-management',
        loadComponent: () => UserManagementComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/user-management'}
      },
      {
        path: 'medicine-unit',
        loadComponent: () => MedicineUnitComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/medicine-unit'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {
}
